import { Language } from '../../lang/Language'

export class PlayStartError extends Error {
  constructor(currentState: string) {
    super(Language.strings.error.table.playStartError(currentState))
  }
}
